import React from 'react';

interface InfoCardProps {
    children: React.ReactNode;
    /** 透传额外的样式（如页面自定义的 padding / marginBottom） */
    style?: React.CSSProperties;
}

/**
 * 统一的信息卡片容器，用于详情页和列表页的卡片包裹。
 * 提供一致的背景色、圆角、边框和主题感知阴影。
 * padding 由各页面通过 style prop 控制（各页面内容布局不同）。
 */
const InfoCard: React.FC<InfoCardProps> = ({ children, style }) => {
    return (
        <div
            style={{
                backgroundColor: 'var(--app-card-bg)',
                borderRadius: 'var(--radius-lg)',
                border: '0.5px solid var(--app-card-border)',
                boxShadow: 'var(--shadow-info-card)',
                ...style,
            }}
        >
            {children}
        </div>
    );
};

export default InfoCard;
